import { FETCH_SIGTRAN_INOUT_MESSAGE,UPDATE_SIGTRAN_INOUT_MESSAGE_FILTER } from "../../../actions/actionTypes";

const initialState = {
    isLoading:false,
    filters:{},
    data:[]
};

const reducer = (state=initialState, action)=>{  
    switch(action.type){
        case FETCH_SIGTRAN_INOUT_MESSAGE.REQUEST:
            return {...state,data:[], isLoading:true}
        case FETCH_SIGTRAN_INOUT_MESSAGE.FAILURE:
            return {...state,data:[], isLoading:false}
        case FETCH_SIGTRAN_INOUT_MESSAGE.SUCCESS:           
            return {...state, data: [...action.data],isLoading:false} 
        case UPDATE_SIGTRAN_INOUT_MESSAGE_FILTER:   
        return {...state, filters:{...state.filters,...action.filters}}         
        default:
            return state
    }   
}

export default reducer;
